/* Autogenerated file. Do not edit manually. */

import { TableId } from "@latticexyz/common";
import { defineComponent, Type as RecsType, World } from "@latticexyz/recs";

export function defineContractComponents(world: World) {
  return {
    NetworkConfig: (() => {
      const tableId = new TableId("", "NetworkConfig");
      return defineComponent(
        world,
        {
          vrfCoordinator: RecsType.String,
          vrfSubId: RecsType.BigInt,
          vrfKeyHash: RecsType.String,
          vrfMinimumRequestConfirmations: RecsType.Number,
          vrfCallbackGasLimit: RecsType.Number,
          vrfNumWords: RecsType.Number,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    GameConfig: (() => {
      const tableId = new TableId("", "GameConfig");
      return defineComponent(
        world,
        {
          gameIndex: RecsType.Number,
          creatureIndex: RecsType.Number,
          length: RecsType.Number,
          width: RecsType.Number,
          roundInterval: RecsType.Number,
          revenue: RecsType.Number,
          rvnGrowthPeriod: RecsType.Number,
          inventorySlotNum: RecsType.Number,
          expUpgrade: RecsType.NumberArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    ShopConfig: (() => {
      const tableId = new TableId("", "ShopConfig");
      return defineComponent(
        world,
        {
          slotNum: RecsType.Number,
          refreshPrice: RecsType.Number,
          expPrice: RecsType.Number,
          tierPrice: RecsType.NumberArray,
          tierRate: RecsType.NumberArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    VrfRequest: (() => {
      const tableId = new TableId("", "VrfRequest");
      return defineComponent(
        world,
        {
          gameId: RecsType.Number,
          fulfilled: RecsType.Boolean,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    PlayerGlobal: (() => {
      const tableId = new TableId("", "PlayerGlobal");
      return defineComponent(
        world,
        {
          roomId: RecsType.String,
          gameId: RecsType.Number,
          status: RecsType.Number,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    Player: (() => {
      const tableId = new TableId("", "Player");
      return defineComponent(
        world,
        {
          health: RecsType.Number,
          streakCount: RecsType.Number,
          coin: RecsType.Number,
          tier: RecsType.Number,
          exp: RecsType.Number,
          heroes: RecsType.StringArray,
          heroAltar: RecsType.BigIntArray,
          inventory: RecsType.BigIntArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    CreatureConfig: (() => {
      const tableId = new TableId("", "CreatureConfig");
      return defineComponent(
        world,
        {
          healthAmplifier: RecsType.NumberArray,
          attackAmplifier: RecsType.NumberArray,
          defenseAmplifier: RecsType.NumberArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    Creature: (() => {
      const tableId = new TableId("", "Creature");
      return defineComponent(
        world,
        {
          health: RecsType.Number,
          attack: RecsType.Number,
          range: RecsType.Number,
          defense: RecsType.Number,
          speed: RecsType.Number,
          movement: RecsType.Number,
          uri: RecsType.String,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    Hero: (() => {
      const tableId = new TableId("", "Hero");
      return defineComponent(
        world,
        {
          creatureId: RecsType.Number,
          tier: RecsType.Number,
          x: RecsType.Number,
          y: RecsType.Number,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    Piece: (() => {
      const tableId = new TableId("", "Piece");
      return defineComponent(
        world,
        {
          x: RecsType.Number,
          y: RecsType.Number,
          tier: RecsType.Number,
          health: RecsType.Number,
          attack: RecsType.Number,
          range: RecsType.Number,
          defense: RecsType.Number,
          speed: RecsType.Number,
          movement: RecsType.Number,
          maxHealth: RecsType.Number,
          creatureId: RecsType.Number,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    WaitingRoom: (() => {
      const tableId = new TableId("", "WaitingRoom");
      return defineComponent(
        world,
        {
          seatNum: RecsType.Number,
          withPassword: RecsType.Boolean,
          players: RecsType.StringArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    WaitingRoomPassword: (() => {
      const tableId = new TableId("", "WaitingRoomPassw");
      return defineComponent(
        world,
        {
          passwordHash: RecsType.String,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    GameRecord: (() => {
      const tableId = new TableId("", "GameRecord");
      return defineComponent(
        world,
        {
          players: RecsType.StringArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    Game: (() => {
      const tableId = new TableId("", "Game");
      return defineComponent(
        world,
        {
          status: RecsType.Number,
          round: RecsType.Number,
          startFrom: RecsType.BigInt,
          finishedBoard: RecsType.Number,
          globalRandomNumber: RecsType.BigInt,
          players: RecsType.StringArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    Board: (() => {
      const tableId = new TableId("", "Board");
      return defineComponent(
        world,
        {
          enemy: RecsType.String,
          status: RecsType.Number,
          turn: RecsType.Number,
          pieces: RecsType.StringArray,
          enemyPieces: RecsType.StringArray,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
    ZkVerifier: (() => {
      const tableId = new TableId("", "ZkVerifier");
      return defineComponent(
        world,
        {
          password: RecsType.String,
        },
        {
          metadata: {
            contractId: tableId.toHex(),
            tableId: tableId.toString(),
          },
        }
      );
    })(),
  };
}
